/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FinesYes.module.scss'
import { useHistory } from 'react-router-dom'
import BackAnchor from '../../../../shared/components/BackAnchor'

const FinesYes = ({ t, i18n }) => {
  const history = useHistory()
  const [isHelperOpen, setIsHelperOpen] = useState(false)

  const getPayAFineUrl = () => {
    const origin = window.location.origin
    if (origin.includes('dev-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://dev-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://dev-finepayments.ds4u.novascotia.dev/fr/amendes-info'
    } else if (origin.includes('test-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://test-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://test-finepayments.ds4u.novascotia.dev/fr/amendes-info'
    } else if (origin.includes('uat-rmvadminfee.ds4u.novascotia.dev')) {
      return i18n.language === 'en'
        ? 'https://uat-finepayments.ds4u.novascotia.dev/en/fine-info'
        : 'https://uat-finepayments.ds4u.novascotia.dev/fr/amendes-info'
    } else {
      return i18n.language === 'en' ? 'https://finepayment.novascotia.ca/en/fine-info' : 'https://finepayment.novascotia.ca/fr/amendes-info'
    }
  }

  const payAFineUrl = getPayAFineUrl()

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <BackAnchor />
          <h1>{t('title')}</h1>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3>
            {t('fines_yes.ensure_all_fines')}
            <a target="_blank" rel="noopener noreferrer" href={payAFineUrl}>
              {t('fines_yes.pay_your_fines')}
              <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
            </a>
            .
          </h3>
        </div>
      </div> */}
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <h3>{t('fines_yes.ensure_all_fines')}</h3>
          <ul>
            <li>
              {t('fines_yes.you_may_be')}
              <a target="_blank" rel="noopener noreferrer" href={payAFineUrl}>
                {t('fines_yes.pay_your_fines')}
                <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
              </a>
              .
            </li>
            <li>
              {t('fines_yes.if_you_are_not')}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  i18n.language === 'en'
                    ? 'https://www.courts.ns.ca/Courthouse_Locations/Courthouse_Locations_Map.htm'
                    : 'https://www.courts.ns.ca/Courthouse_Locations/Courthouse_Locations_Map.htm'
                }
              >
                {t('fines_yes.court')}
                <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
              </a>
              {t('fines_yes.en_anglais')}.
            </li>
          </ul>
        </div>
      </div>
      {/* <div className="row">
        <div className="col-xs-12 col-md-8">
          <div className="help-field">
            <i className={['fa fa-exclamation-circle', styles['exclamation_margin_right']].join(' ')} aria-hidden="true"></i>
            <a className="fines_not_sure" tabIndex="0" onClick={() => setIsHelperOpen(!isHelperOpen)}>
              {t('fines_yes.not_sure_what_fines')}
              <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
            </a>{' '}
          </div>
          {isHelperOpen && (
            <div className={styles['helper_content']}>
              <blockquote className={styles['blockquote_font']}>
                <p>
                  {t('fines_yes.if_you_are_not')}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      i18n.language === 'en'
                        ? 'https://www.courts.ns.ca/Courthouse_Locations/Courthouse_Locations_Map.htm'
                        : 'https://www.courts.ns.ca/Courthouse_Locations/Courthouse_Locations_Map.htm'
                    }
                  >
                    {t('fines_yes.court')}
                    <span className="ns-visually-hidden">{t('open_in_a_new_tab')}</span>
                  </a>
                  {t('fines_yes.en_anglais')}.
                </p>
              </blockquote>
            </div>
          )}
        </div>
      </div> */}
    </div>
  )
}

export default withTranslation('common')(FinesYes)
